// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2454": "14f2d8306efa","5555": "7c923806eefd","8934": "5b9dd02e38df",}[chunkId] + ".css"
}